import React, {useState} from "react";
import AdminNavbar from "../components/navbar/adminNavbar";
import WithSidebar from "../components/withSidebar/withSidebar";
import { isEmptyDash } from "../constant";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "../views/common/confirmModal";

// function getRoutes(routesParamArr){
//   return routesParamArr.map((prop, key) => {
//     // if (prop.collapse) {
//     //   return this.getRoutes(prop.views);
//     // }
//     if (prop.layout === "/admin") {
//       return (
//         <Route path={prop.path} Component={prop.component} key={key} />
//       );
//     } else {
//       return null;
//     }
//   });
// };

// const CustomModal = ({ show, onConfirm, onCancel, msg }) => {
//   if (!show) return null;

//   return (
//     <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)" }}>
//       <div style={{ margin: "15% auto", padding: "20px", backgroundColor: "#fff", width: "300px", textAlign: "center" }}>
//         <p>{msg}</p>
//         <button onClick={onConfirm} style={{ marginRight: "10px" }}>Yes</button>
//         <button onClick={onCancel}>No</button>
//       </div>
//     </div>
//   );
// };

function Admin(props) {
  const [showModal, setShowModal] = useState(false);
  const [nextPath, setNextPath] = useState(null);
  const [isBlocking, setIsBlocking] = useState(false);
  const [msgContent, setMsgContent] = useState("");
  const navigate = useNavigate();

  const handleNavigation = (path) => {    
    let isAlertUnsavedData = JSON.parse(sessionStorage.getItem("isAlertUnsavedData"));
    console.log("handleNavigation: ",isAlertUnsavedData);

    if (!isEmptyDash(isAlertUnsavedData)) {
      setNextPath(path);
      setMsgContent(isAlertUnsavedData?.msg);
      setShowModal(true);
    }
    else {
      sessionStorage.removeItem("isAlertUnsavedData");
      navigate(path);
    }
  };

  const confirmNavigation = () => {
    setShowModal(false);
    setIsBlocking(false);
    sessionStorage.removeItem("isAlertUnsavedData");
    if (nextPath) navigate(nextPath);
  };

  const cancelNavigation = () => {
    setShowModal(false);
    setNextPath(null);
    sessionStorage.removeItem("isAlertUnsavedData");
  };

  if (isEmptyDash(JSON.parse(sessionStorage.getItem("user")))) {
    window.location.href = '/auth/login';
  }
  else {
    return (
      <>
        <AdminNavbar handleNavigation={handleNavigation} />
        <WithSidebar handleNavigation={handleNavigation} /> 
        {/* <CustomModal show={showModal} onConfirm={confirmNavigation} onCancel={cancelNavigation} msg={msgContent} /> */}
        
        <ConfirmModal
          isConfirmModalOpen={showModal}
          closeConfirmModal={cancelNavigation}
          successConfirmModal={confirmNavigation}
          modalMsg={msgContent}
          status={""}
        />
     
      </>
    );
  }

}

export default Admin;
